<template>
    <b-row class="d4d-legalmessage">
        <b-col cols="12" class="mt-3 text-center">
            <span class="legal-text">Legal Privacy Security</span>
        </b-col>
        <b-col cols="12" class="mt-1 mb-4 text-center">
            <span class="legal-text">
                © {{new Date().getFullYear()}} Intuit, Inc. All rights reserved.
                Intuit, QuickBooks, QB, TurboTax, ProConnect and Mint are
                registered trademarks of Intuit Inc. Terms and conditions,
                features, support, pricing, and service options subject
                to change without notice.
            </span>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        name: "LegalMessage"
    }
</script>

<style lang="stylus" scoped>
    .legal-text
        font-family arial, sans-serif
        font-size 14px
        font-weight 400
        color #505050
</style>